'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _Confirmation = require('./Confirmation');

var _Confirmation2 = _interopRequireDefault(_Confirmation);

var _utilsLib = require('utils-lib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = require('moment');
moment().format();

var ConfirmationsModel = function (_PagingModel) {
    _inherits(ConfirmationsModel, _PagingModel);

    /**
     * Liste von Dokumenten
     * @type {array} of Nachweise
     */


    /**
     * War das Löschen des Nachweises erfolgreich?
     * @type {boolean}
     */
    function ConfirmationsModel(observers, id, request) {
        _classCallCheck(this, ConfirmationsModel);

        var _this = _possibleConstructorReturn(this, (ConfirmationsModel.__proto__ || Object.getPrototypeOf(ConfirmationsModel)).call(this, observers, id, request));

        _this.Confirmations = [];

        _this.DeleteSuccess = false;

        _this.UploadSuccess = false;
        return _this;
    }

    /**
     * War das Hochland des Nachweises erfolgreich?
     * @type {boolean}
     */


    _createClass(ConfirmationsModel, [{
        key: 'GetConfirmationsByCustomerId',
        value: function GetConfirmationsByCustomerId(customerId, senddata, start, limit, orderColumn, orderDirection) {

            var reqString = "/Confirmations";
            if (senddata !== null && senddata !== undefined) {
                reqString += senddata;
                if (customerId !== null && customerId !== undefined) {
                    reqString += "&customerId=" + customerId;
                }
            } else {
                var paramsCount = 0;
                var params = [];
                if (customerId !== null && customerId !== undefined) {
                    paramsCount++;
                    params.push({ Param: "customerId", Value: customerId });
                }
                if (start !== null && start !== undefined) {
                    paramsCount++;
                    params.push({ Param: "start", Value: start });
                }
                if (limit !== null && limit !== undefined) {
                    paramsCount++;
                    params.push({ Param: "limit", Value: limit });
                }
                if (orderColumn !== null && orderColumn !== undefined) {
                    paramsCount++;
                    params.push({ Param: "orderColumn", Value: orderColumn });
                }
                if (orderDirection !== null && orderDirection !== undefined) {
                    paramsCount++;
                    params.push({ Param: "orderDirection", Value: orderDirection });
                }

                if (paramsCount > 0) {
                    reqString += "?";
                    for (var i = 0; i < params.length; i++) {
                        reqString += params[i].Param + "=" + params[i].Value;
                        if (i < paramsCount - 1) {
                            reqString += '&';
                        }
                    }
                }
            }

            var me = this;

            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        var data = result.Data;
                        if (data.Count !== undefined && data.Count !== null) {
                            me.Count = data.Count;
                        }
                        if (data.Start !== undefined && data.Start !== null) {
                            me.Start = data.Start;
                        }
                        if (data.Limit !== undefined && data.Limit !== null) {
                            me.Limit = data.Limit;
                        }
                        if (data.OrderColumn !== undefined && data.OrderColumn !== null) {
                            me.OrderColumn = data.OrderColumn;
                        }
                        if (data.OrderDirection !== undefined && data.OrderDirection !== null) {
                            me.OrderDirection = data.OrderDirection;
                        }

                        var documents = [];
                        var _i = 0;

                        if (data.Data) {
                            data.Data.forEach(function (value) {
                                var document = {};

                                if (value.DocumentIdent == "") {
                                    document.Id = "NoDocument" + _i;

                                    _i++;
                                } else {
                                    document.Id = value.DocumentIdent;
                                }

                                document.Name = value.Name;
                                if (_utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateFrom, true, localStorage.getItem('vas_language'))) !== '01.01.0001' && _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateFrom, true, localStorage.getItem('vas_language'))) !== '01/01/0001') {
                                    document.DateFrom = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateFrom, true, localStorage.getItem('vas_language')));
                                } else {
                                    document.DateFrom = '';
                                }
                                if (_utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateTo, true, localStorage.getItem('vas_language'))) !== '01.01.0001' && _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateTo, true, localStorage.getItem('vas_language'))) !== '01/01/0001') {
                                    document.DateTo = _utilsLib.DateTimeHelper.FormatToShortDateString(_utilsLib.DateTimeHelper.StringToDate(value.DateTo, true, localStorage.getItem('vas_language')));
                                } else {
                                    document.DateTo = '';
                                }
                                if (value.IdentificationNumber !== "undefined") {
                                    document.IdentificationNumber = value.IdentificationNumber;
                                } else {
                                    document.IdentificationNumber = '';
                                }
                                documents.push(document);

                                _i++;
                            });
                        }
                        me.Confirmations = documents;
                    }
                }
                var id = me.Id ? me.Id : "Confirmations";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'GetAllConfirmations',
        value: function GetAllConfirmations() {
            var me = this;
            this.request.setRequest("/confirmations/all");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    var verifications = [];
                    if (result.Data) {
                        result.Data.forEach(function (value) {
                            var verification = new _Confirmation2.default();
                            verification.Ident = value.Ident;
                            verification.Name = value.Name;
                            verification.DateFromAllowed = value.DateFrom;
                            verification.DateToAllowed = value.DateTo;
                            verification.IdentificationNumberAllowed = value.IdentificationNumber;
                            verification.Description = value.Description;
                            verification.MinAge = value.MinAge;
                            verification.MaxAge = value.MaxAge;
                            verifications.push(verification);
                        });
                    }
                    me.Confirmations = verifications;
                }
                var id = me.Id ? me.Id : "ConfirmationsAll";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'UploadConfirmation',
        value: function UploadConfirmation(customerId, confirmationId, datefrom, dateto, identificationNumber, files) {
            var me = this;
            this.request.setRequest("/Confirmations");
            this.request.setDataType(null);
            this.request.setContentType(false);
            this.request.setType("POST");

            var formData = new FormData();

            for (var i = 0; i < files.length; i++) {
                if (files[i]) {
                    if (files[i].name) {
                        formData.append("file", files[i], files[i].name);
                    }
                }
            }

            formData.append("customerId", customerId);

            formData.append("confirmationId", confirmationId);

            formData.append("datefrom", datefrom);

            formData.append("dateto", dateto);

            formData.append("identificationNumber", identificationNumber);

            this.request.setData(formData);

            this.request.setProcessData(false);

            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.UploadSuccess = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "UploadConfirmation";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'GetConfirmationsByTicketId',
        value: function GetConfirmationsByTicketId(ticketId, bday) {
            var me = this;
            if (ticketId !== null && ticketId !== undefined) {
                var req = "/Tickets/" + ticketId + "/Confirmations";
                if (bday !== null && bday !== undefined) {
                    req += "?bday=" + bday;
                }
                this.request.setRequest(req);
                this.request.setType("GET");
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.Confirmations = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "ConfirmationsByTicketId";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }]);

    return ConfirmationsModel;
}(_PagingModel3.default);

exports.default = ConfirmationsModel;